// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__-mQcn"};